import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { enqueueSnackbar } from './snackbar';
import * as ENVIRONMENT from '../../shared/config/config';
import { listWells } from './wells';
import { modifyMetricData } from '../../utils/getMetrics';
import { VERSION } from '../../shared/config/version';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
export const listWellsGeometry = (wellId, closeDialog) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .post('wells/entity/geometry/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: geometryData, units } = data;
      const modifiedGeometryData = modifyMetricData(geometryData, units, currentUnit);
      dispatch({
        type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_SUCCESS,
        payload: {
          ...data,
          data: modifiedGeometryData,
          paginatedElements: modifiedGeometryData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      if (error?.status === 403) {
        closeDialog?.();
      }
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
export const addNewGeometryRow = () => (dispatch) => {
  const { wellsGeometry } = store.getState();
  const newGeometry = [...wellsGeometry.data];
  const existUnit = { ...wellsGeometry.units };
  const nextId = newGeometry.length - 1;
  const newRow = {
    type: 'Casing',
    top_md: '',
    shoe_md: '',
    id: '',
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true,
  };

  newGeometry.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_SUCCESS,
    payload: {
      data: newGeometry,
      units: existUnit,
      paginatedElements: newGeometry.length,
    },
  });
};
export const createGeometry = (body, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_LOADING,
  });
  delete body._id;
  delete body.isDirty;
  const input = {
    query: {
      wellsInfoId: wellId
    },
    input: {
      ...body,
    }
  };
  return fetchAPI
    .post('wells/entity/geometry/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Geometry Details Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
    });
};
export const updateGeometry = (body, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_LOADING,
  });
  const input = {
    query: {
      _id: body?._id,
      wellsInfoId: wellId
    },
    input: {
      ...body
    }
  };
  return fetchAPI
    .put('wells/entity/geometry', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Geometry Details Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
    });
};
export const deleteGeometryRow = (deleteSurveyId, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_LOADING,
  });
  const body = {
    query: {
      _id: deleteSurveyId,
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .deleteAction('wells/entity/geometry', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Geometry Details Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listWellsGeometry(wellId));
    });
};

export const importWellsGeometryCSVFIle = (file, wellId) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_GEOMETRY_LIST_LOADING,
  });
  const formData = new FormData();
  const { currentUser } = store.getState();
  const ipDetails = {
    ip: currentUser?.ip,
  };
  const BASE_URL = ENVIRONMENT.API_URL;
  formData.append('file', file);
  const payload = {
    input: {
      wellsInfoId: wellId
    },
    user: {
      type: currentUser.type,
      companyId: currentUser.companyId,
      userId: currentUser.userId,
      ...(ipDetails?.ip && { ...ipDetails }),
      version: VERSION
    },
  };
  formData.append('payload', JSON.stringify(payload));
  try {
    const response = await fetch(`${BASE_URL}wells/entity/geometry/import`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    if (response.status !== 200) {
      throw new Error(response.statusText || 'Failed to import CSV');
    }
    dispatch(
      enqueueSnackbar(
        'CSV Imported Successfully',
        'success',
        new Date().getTime() + Math.random()
      )
    );
    dispatch(listWellsGeometry(wellId));
  } catch (error) {
    dispatch(
      enqueueSnackbar(
        'Failed to import CSV file',
        'error',
        new Date().getTime() + Math.random()
      )
    );
    dispatch(listWellsGeometry(wellId));
  }
};
